import {useEffect} from "react";
import {useAspSsoLinkStore} from "store/asp/asp-sso-link.store";
import {shallow} from "zustand/shallow";

type UseCurrentShowResult = [string | null, boolean];

const useAspSsoLink = (showId: string): UseCurrentShowResult => {
  const {fetch} = useAspSsoLinkStore();

  const isLoading = useAspSsoLinkStore((state) => state.isLoading, shallow);
  const link = useAspSsoLinkStore(
    ({getByShowId}) => getByShowId(showId),
    shallow
  );

  useEffect(() => {
    if (showId) {
      fetch(showId);
    }
  }, [showId]);

  return [link, isLoading];
};

export default useAspSsoLink;
